import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import CustomPrimeTable, { DEFAULT_PAGE_SAZE } from '../../common/PrimeTable/CustomPrimeTable'
import useContactUrl from '../../hooks/useContactUrl'
import camelToSnake from '../../utils/camelToSnake'
import { clearSalesMetricContacts, getContactsForSalesMetric } from './Redux/salesMetricReportActions'

const DEFAULT_PAGINATION = { limit: DEFAULT_PAGE_SAZE, first: 0 }
const DEFAULT_SORT_META = [{ field: 'name', order: -1 }]

const SalesReportContactTable = (props) => {
  const {
    divisionId,
    userId,
    statusId,
    creationDate,
    allProspects,
    allAccounts,
    isRfp,
    isMfp,
    isCreditApp,
    isOnlineForm,
  } = props

  const [options, setOptions] = useState({
    pagination: DEFAULT_PAGINATION,
    sort: { name: -1 },
    filter: {
      divisionId: divisionId,
      statusId: statusId,
      assigned: userId,
      dateRange: creationDate,
      allProspects,
      allAccounts,
      isRfp,
      isMfp,
      isCreditApp,
      isOnlineForm,
    },
    tableFilter: {},
  })

  const { contacts } = useSelector((state) => ({
    contacts: state.SalesMetricReport.contacts,
  }))

  const dispatch = useDispatch()

  const { getUrl } = useContactUrl()

  useEffect(() => {
    dispatch(getContactsForSalesMetric(options))
  }, [options])

  useEffect(() => {
    return () => {
      dispatch(clearSalesMetricContacts())
    }
  }, [])

  const onFilterChange = async (event) => {
    let tableFilter = {}
    Object.keys(event.filters).forEach(function (key) {
      tableFilter[camelToSnake(key)] = event.filters[key].value
    })
    setOptions({
      ...options,
      tableFilter,
      pagination: DEFAULT_PAGINATION,
    })
  }

  const onSortChange = async (event) => {
    let sort = {}
    if (event.multiSortMeta) {
      event.multiSortMeta.map((row) => {
        return (sort[row.field] = row.order)
      })
    }

    setOptions({
      ...options,
      sort,
      pagination: DEFAULT_PAGINATION,
    })
  }

  const onPageChange = async (event) => {
    const pagination = { limit: event.rows, first: event.first }
    setOptions({ ...options, pagination })
  }

  const contactBody = (rowData) => {
    return (
      <button className='btn btn-sm btn-link m-0 p-0' onClick={() => window.open(getUrl(rowData), '_blank')}>
        {rowData.name}
      </button>
    )
  }

  const columns = [
    { field: 'name', style: { textAlign: 'center' }, header: 'Contact', body: contactBody },
    { field: 'mcNumber', style: { textAlign: 'center' }, header: 'MC Number' },
    { field: 'addressCity', style: { textAlign: 'center' }, header: 'Address City' },
    { field: 'addressState', style: { textAlign: 'center' }, header: 'State' },
    { field: 'numberOfTrucks', style: { textAlign: 'center' }, header: 'Number of Trucks' },
    { field: 'ownerName', style: { textAlign: 'center' }, header: 'Company Owner' },
    { field: 'nationality', style: { textAlign: 'center' }, header: 'Preferred Language' },
    { field: 'businessPhone', style: { textAlign: 'center' }, header: 'Business Phone' },
    {
      field: 'lastContactDate',
      style: { textAlign: 'center' },
      header: 'Last Contact Date',
      format: 'MM-DD-YYYY',
    },
    {
      field: 'lastMeetingDate',
      style: { textAlign: 'center' },
      header: 'Last Meeting Date',
      format: 'MM-DD-YYYY',
    },
    { field: 'userName', style: { textAlign: 'center' }, header: 'Assigned' },
  ]

  return (
    <>
      <CustomPrimeTable
        data={contacts.data}
        columns={columns}
        defaultSortMeta={DEFAULT_SORT_META}
        findHidden={true}
        addHidden={true}
        onFilter={onFilterChange}
        onSort={onSortChange}
        onPage={onPageChange}
        query={contacts.query}
        showActions={false}
      />
    </>
  )
}

export default SalesReportContactTable
